import { ReactComponent as PlayButtonSVG } from '@/assets/images/svg/buttons/play-button.svg';
import { Container } from '@/components/layout/Container';
import { COLORS } from '@/styles/color';
import { hexToRGBA } from '@/styles/color/utils';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize } from '@/styles/typography/utils';
import styled from 'styled-components';

const Section = styled.section`
  padding: 40px 0;
  overflow: hidden;
`;

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  row-gap: 30px;

  ${mediaBreakpointUp('tablet')} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
    align-items: center;
  }

  ${mediaBreakpointUp('desktop')} {
    grid-template-columns: repeat(18, 1fr);
  }

  ${mediaBreakpointUp('desktopWide')} {
    grid-template-columns: repeat(12, 1fr);
  }
`;

const Heading = styled.h2`
  ${customTextSize(32, 38)}
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  margin-bottom: 20px;

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(49, 58)}
    margin-bottom: 40px;
  }
`;

const WatchVideoButton = styled.button`
  display: inline-flex;
  align-items: center;
  ${customTextSize(16, 19)}
  font-weight: ${FONT_WEIGHTS.BOLD};

  span {
    border-bottom: 2px solid;
    margin-right: 11px;
  }

  svg {
    transition: transform 0.2s ease-in-out;
  }

  &:hover {
    svg {
      transform: scale(1.15);
    }
  }
`;

const ContentWrapper = styled.div`
  ${mediaBreakpointUp('desktop')} {
    grid-column: 2 / span 6;
  }

  ${mediaBreakpointUp('desktopWide')} {
    grid-column: 2 / span 4;
  }
`;

const PlayButton = styled(PlayButtonSVG)`
  --play-button-size: 60px;

  position: absolute;
  top: calc(50% - (var(--play-button-size) / 2));
  left: calc(50% - (var(--play-button-size) / 2));
  width: var(--play-button-size);
  z-index: 2;
  transform: scale(1);
  transform-origin: center;
  transition: transform 0.4s ease-in-out, box-shadow 0.4s ease-in-out;
  box-shadow: 0 0 30px 10px ${hexToRGBA(COLORS.BLACK, 0.25)};
  border-radius: 100%;
  pointer-events: none;
  background-color: ${COLORS.WHITE};

  ${mediaBreakpointUp('desktop')} {
    --play-button-size: 120px;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    ${PlayButton} {
      transform: scale(1.1);
    }
  }

  ${mediaBreakpointUp('desktop')} {
    grid-column: 9 / -1;
  }

  ${mediaBreakpointUp('desktopWide')} {
    grid-column: 7 / span 6;
  }
`;

const VideoBannerComponents = {
  Section,
  StyledContainer,
  Heading,
  WatchVideoButton,
  ContentWrapper,
  ImageWrapper,
  PlayButton,
};

export default VideoBannerComponents;
